export enum EShippingStatus {
    ORDER_PLACED = 'ORDER_PLACED',
    PROCESSING = 'PROCESSING',
    SHIPPED = 'SHIPPED',
    DELIVERED = 'DELIVERED',
}
